// helper
import Util from "@/helper/Utility.js";
// model
import { QueryStringDataModel } from "./QueryStringDataModel";
export function QueryStringDataBuilder() {
    this.queryStringDataModel = new QueryStringDataModel();

    this.create = function () {
        return this.queryStringDataModel;
    };
    //#region setter
    this.setWithQuery = function (dict) {
        // console.log(dict.token)
        this.setAppId(dict.app_id);
        this.setAppName(dict.appName);
        this.setApiPrefix(dict.api);
        this.setCampaignId(dict.campaignId ? dict.campaignId : dict.campaign_id);
        this.setContactNumber(dict.contact_number);
        this.setEWalletToken(dict.wallet_token);
        this.setHistoryUrl(dict.history_url);
        this.setLocale(dict.locale);
        this.setOtp(dict.otp);
        this.setRefcode(dict.refcode);
        this.setReturnUrl(dict.return_url);
        this.setRawToken(dict.token)
        this.setToken(dict.token);
        this.setTheme(dict.theme);
        this.setWalletCardId(dict.wallet_card_id);
        this.setWithHoldingTaxKey(dict.withholdingtax_key);
        this.setShoppingCartUrl(dict.shoppingcart_url);
        this.setShoppingCartApi(dict.shoppingcart_api);
        this.setPartialPoints(dict.partial_points);
        this.setPartialBaht(dict.partial_baht);
        this.setLoginName(dict.loginName);
        this.setIsTest(dict.is_test);
        this.setInfo1(dict?.info1 ?? null);
        this.setInfo2(dict?.info2 ?? null);
        this.setInfo3(dict?.info3 ?? null);
        this.setInfo4(dict?.info4 ?? null);
        this.setInfo5(dict?.info5 ?? null);
        this.setHeader(dict?.header ?? null);
        this.setRedeemKey(dict.redeem_key);

        return this;
    };
    this.setRawToken = function(token){
        this.queryStringDataModel.rawToken = token
    }
    this.setAppId = function (app_id) {
        this.queryStringDataModel.appId = Util.isEmptyStr(app_id) ? null : app_id;
        return this;
    };
    this.setAppName = function (appName) {
        this.queryStringDataModel.appName = Util.isEmptyStr(appName) ? null :appName;
        return this;
    };
    this.setApiPrefix = function (apiPrefix) {
        this.queryStringDataModel.apiPrefix = Util.isEmptyStr(apiPrefix) ? null :apiPrefix;
        return this;
    };
    this.setCampaignId = function (campaignId) {
        this.queryStringDataModel.campaignId = Util.isEmptyStr(campaignId) ? null : campaignId;
        return this;
    };
    this.setContactNumber = function (contact_number) {
        this.queryStringDataModel.contact_number = Util.isEmptyStr(contact_number) ? null : contact_number;
        return this;
    };
    this.setEWalletToken = function (wallet_token) {
        const reshuffledWalletToken = Util.isEmptyStr(wallet_token) ? null : Util.reShuffleToken(wallet_token);
        this.queryStringDataModel.wallet_token = reshuffledWalletToken;
        return this;
    };
    this.setHistoryUrl = function (historyUrl) {
        this.queryStringDataModel.historyUrl = Util.isEmptyStr(historyUrl) ? null : historyUrl;
        return this;
    };
    this.setLocale = function (locale) {
        this.queryStringDataModel.locale = Util.isEmptyStr(locale) ? null : locale;
        return this;
    };
    this.setLoginName = function (loginName) {
        this.queryStringDataModel.loginName = Util.isEmptyStr(loginName) ? null : loginName;
        return this;
    };
    this.setPartialPoints = function (partial_points) {
        this.queryStringDataModel.partial_points = Util.isEmptyStr(partial_points) ? null : partial_points;
        return this;
    };
    this.setPartialBaht = function (partial_baht) {
        this.queryStringDataModel.partial_baht = Util.isEmptyStr(partial_baht) ? null : partial_baht;
        return this;
    };
    this.setOtp = function (otp) {
        this.queryStringDataModel.otp = Util.isEmptyStr(otp) ? null : otp;
        return otp;
    };
    this.setRefcode = function (refcode) {
        this.queryStringDataModel.refcode = Util.isEmptyStr(refcode) ? null : refcode;
        return refcode;
    };
    this.setReturnUrl = function (returnUrl) {
        this.queryStringDataModel.returnUrl = Util.isEmptyStr(returnUrl) ? null : returnUrl;
        return this;
    };
    this.setToken = function (token) {
        const reshuffledToken = Util.isEmptyStr(token) ? null : Util.reShuffleToken(token);
        // console.log(Util.isEmptyStr(token) ? null : Util.reShuffleToken(token))
        this.queryStringDataModel.token = reshuffledToken;
        return this;
    };
    this.setTheme = function (theme) {
        this.queryStringDataModel.theme =  Util.isEmptyStr(theme) ? null : theme;
        return this;
    };
    this.setWalletCardId = function (wallet_card_id) {
        this.queryStringDataModel.walletCardId = Util.isEmptyStr(wallet_card_id) ? null : wallet_card_id;
        return this;
    };
    this.setWithHoldingTaxKey = function (withholdingtax_key) {
        this.queryStringDataModel.withholdingtax_key = Util.isEmptyStr(withholdingtax_key) ? null : withholdingtax_key;
        return this;
    };
    this.setShoppingCartUrl = function (shoppingCartUrl) {
        this.queryStringDataModel.shoppingCartUrl = Util.isEmptyStr(shoppingCartUrl) ? null : shoppingCartUrl;
        return this;
    };
    this.setShoppingCartApi = function (shoppingCartApi) {
        this.queryStringDataModel.shoppingCartApi = Util.isEmptyStr(shoppingCartApi) ? null : shoppingCartApi;
        return this;
    };
    this.setIsTest = function (isTest) {
        this.queryStringDataModel.is_test = isTest;
        return this;
    };
    this.setInfo1 = function (val) {
        this.queryStringDataModel.info1 = val;
        return this;
    };
    this.setInfo2 = function (val) {
        this.queryStringDataModel.info2 = val;
        return this;
    };
    this.setInfo3 = function (val) {
        this.queryStringDataModel.info3 = val;
        return this;
    };
    this.setInfo4 = function (val) {
        this.queryStringDataModel.info4 = val;
        return this;
    };
    this.setInfo5 = function (info5) {
        this.queryStringDataModel.info5 = info5;
        return this;
    };
    this.setHeader = function (val) {
        this.queryStringDataModel.header = val;
        return this;
    };
    this.setRedeemKey = function (val) {
        this.queryStringDataModel.redeemKey = val;
        return this;
    };

    //#endregion setter
}
